module.exports = __webpack_public_path__ + "img/16d004-24.cf203315.png";